import ScrollService from './NativeScroll'
// import ScrollService from './VirtualScroll'

ScrollService.getScrollOffset = () => {
    let offset = 0
    const pageNav = document.querySelector('.PageNavigation.is-clone')

    if (pageNav) {
        offset += pageNav.offsetHeight
    }

    return offset
}

export const disableScroll = () => ScrollService.disableScroll()
export const enableScroll = () => ScrollService.enableScroll()
export const getScroll = () => ScrollService.getScroll()
export const getScrollTop = () => ScrollService.getScrollTop()
export const scrollToElement = (element, options) => ScrollService.scrollToElement(element, options)

export default ScrollService